import { useRef, useState } from 'react';
import Cookie from 'js-cookie';
import { Link } from '@zoopla-eng/zds/link';
import { Box } from '@zoopla-eng/zds/box';
import { Navigation, trackAccount, trackNav } from './data';
import { Divider } from '@zoopla-eng/zds/divider';
import { fontGroups } from '@zoopla-eng/zds/themes';
import {
    drawerListItemStyle,
    drawerListStyle,
    navButtonStyle
} from './Header.styles.css';
import { MenuMedium } from '@zoopla-eng/zds/icons';
import { ControlledDialog } from '@zoopla-eng/zds/dialog';

interface MenuProps {
    isLoggedIn: boolean;
    signinUrl: string;
}

function Menu({ isLoggedIn, signinUrl }: MenuProps) {
    const [dialogIsOpen, setDialogIsOpen] = useState(false);

    const onTriggerClick = () => {
        setDialogIsOpen(!dialogIsOpen);
    };

    const onClose = () => {
        setDialogIsOpen(false);
    };

    const container = useRef(null);

    return (
        <div ref={container}>
            <button
                className={navButtonStyle}
                aria-label="Open Menu"
                data-testid="header-mobile-hamburger"
                data-state={'closed'}
                onClick={onTriggerClick}
            >
                <MenuMedium />
                <span className={fontGroups.zester}>Menu</span>
            </button>
            <ControlledDialog
                isOpen={dialogIsOpen}
                label="Mobile menu"
                onClose={onClose}
                container={container.current}
                variant="sideSheetLeft"
            >
                <div
                    // className={styledContentStyle}
                    aria-label="Main menu"
                    aria-labelledby={undefined}
                    aria-describedby={undefined}
                    data-state={'open'}
                    onAnimationEnd={() => {
                        document.body.style.removeProperty('pointer-events');
                    }}
                >
                    <nav aria-label="Main menu">
                        <ul className={`${drawerListStyle} ${fontGroups.mug}`}>
                            {Navigation.map(({ title, href }) => (
                                <li className={drawerListItemStyle} key={href}>
                                    <Link
                                        href={href}
                                        onClick={
                                            title === 'My home'
                                                ? trackAccount(
                                                      title.toLowerCase()
                                                  )
                                                : trackNav(title)
                                        }
                                        muted
                                        withIcon
                                        disableVisited
                                    >
                                        {title}
                                    </Link>
                                </li>
                            ))}
                            <li
                                className={drawerListItemStyle}
                                key={'/my-zoopla/'}
                            >
                                <Link
                                    href={'/my-zoopla/'}
                                    onClick={trackNav('/my-zoopla/')}
                                    muted
                                    withIcon
                                    disableVisited
                                >
                                    <span>Account</span>
                                </Link>
                            </li>
                        </ul>
                        <Box py="S400">
                            <Divider direction="horizontal" />
                        </Box>
                        <Box
                            pt="S500"
                            px="S500"
                            pb="M200"
                            className={`${fontGroups.mug}`}
                        >
                            {!isLoggedIn ? (
                                <Link
                                    href={signinUrl}
                                    onClick={trackAccount('sign in')}
                                    muted
                                    withIcon
                                    disableVisited
                                >
                                    <span>Sign in</span>
                                </Link>
                            ) : (
                                <Link
                                    href="/?signout=1"
                                    onClick={() => Cookie.remove('adb_he')}
                                    muted
                                    withIcon
                                    disableVisited
                                >
                                    <span>Sign out</span>
                                </Link>
                            )}
                        </Box>
                    </nav>
                </div>
            </ControlledDialog>
        </div>
    );
}
Menu.displayName = 'Menu';

export default Menu;
